import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { hasHelp as hasHelpText, help as helpText } from "./terms";
import ConfigurationMarkdown from "@/components/ObjectStore/ConfigurationMarkdown.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HelpText',
    props: {
        uri: null,
        text: null
    },
    setup(__props) {
        const props = __props;
        const hasHelp = computed(() => {
            return hasHelpText(props.uri);
        });
        const help = computed(() => {
            return helpText(props.uri);
        });
        return { __sfc: true, props, hasHelp, help, ConfigurationMarkdown };
    }
});
